import CustomContextPad from './CustomContextPad';
import CustomPalette from './CustomPalette';
import CustomMenuProvider from './CustomMenuProvider';
import CustomRenderer from "./CustomRenderer";


export default {
    __init__: ['customContextPad', 'customPalette', 'customMenuProvider', 'customRenderer'],
    customContextPad: ['type', CustomContextPad],
    customPalette: ['type', CustomPalette],
    customMenuProvider: ['type', CustomMenuProvider],
    customRenderer: ['type', CustomRenderer]
};
